import React from "react";

import { Trans, useTranslation } from "gatsby-plugin-react-i18next";
import { ErrorRenderer, Field, useField } from "./common";

const VALID_EMAIL_PATTERN = /.+@.+\..+/;
const VALID_PHONE_PATTERN = /^[-./+0-9 ]+$/;

const validateOrganization = (t, companyName) => {
  if (!companyName?.length || companyName.length < 2) {
    return t("sign-up.errors.company-name-is-required");
  }
};

const validateSiret = (t, siret) => {
  if (!siret?.length || siret.length < 14) {
    return t("sign-up.errors.siret-is-invalid");
  }
};

export const validateFirstName = (t, firstName) => {
  if (!firstName?.length) {
    return t("sign-up.errors.first-name-is-required");
  }
};

export const validateLastName = (t, lastName) => {
  if (!lastName?.length) {
    return t("sign-up.errors.last-name-is-required");
  }
};

export const validateEmail = (t, email) => {
  const trimmedEmail = email?.trim() ?? "";

  if (!trimmedEmail.length || !VALID_EMAIL_PATTERN.test(trimmedEmail)) {
    return t("sign-up.errors.invalid-email");
  }
};

export const validatePhone = (t, phone) => {
  const trimmedPhone = phone?.trim() ?? "";

  if (!trimmedPhone.length || !VALID_PHONE_PATTERN.test(trimmedPhone)) {
    return t("sign-up.errors.phone-is-required");
  }
};

const CoordPart = ({ tag, defaults, onContinue, saving, globalError }) => {
  const { t } = useTranslation();

  const organization = useField(defaults.organization, validateOrganization);
  const siret = useField(defaults.siret, validateSiret);
  const firstName = useField(defaults.firstName, validateFirstName);
  const lastName = useField(defaults.lastName, validateLastName);
  const email = useField(defaults.email, validateEmail);
  const phone = useField(defaults.phone, validatePhone);

  const allFields = [organization, siret, firstName, lastName, email, phone];

  return (
    <div className="su-main fl-blue-context">
      <div className="fl-tag fl-naked-tag">{tag}</div>
      <h2>
        <Trans i18nKey="sign-up.coords.title" />
      </h2>

      <Field
        label={t("sign-up.coords.organization.label")}
        field={organization}
        id="organization"
        autoComplete="organization"
        placeholder={t("sign-up.coords.organization.placeholder")}
      />

      <Field
        label={t("sign-up.coords.siret.label")}
        field={siret}
        id="siret"
        placeholder={t("sign-up.coords.siret.placeholder")}
      />

      <div className="su-two-fields">
        <Field
          label={t("sign-up.coords.first-name.label")}
          field={firstName}
          id="first-name"
          autoComplete="given-name"
          placeholder={t("sign-up.coords.first-name.placeholder")}
        />
        <Field
          label={t("sign-up.coords.last-name.label")}
          field={lastName}
          id="last-name"
          autoComplete="given-name"
          placeholder={t("sign-up.coords.last-name.placeholder")}
        />
      </div>

      <Field
        label={t("sign-up.coords.email.label")}
        field={email}
        id="email"
        autoComplete="email"
        placeholder={t("sign-up.coords.email.placeholder")}
      />

      <Field
        label={t("sign-up.coords.phone.label")}
        field={phone}
        id="phone"
        autoComplete="tel"
        placeholder={t("sign-up.coords.phone.placeholder")}
      />

      <ErrorRenderer errorMessage={globalError} />

      <p className="su-next-wrapper">
        <button
          className={`su-next ${saving ? "su-next--saving" : ""}`}
          disabled={allFields.some(field => Boolean(field.validator()))}
          onClick={() => onContinue(...allFields.map(field => field.value))}>
          <Trans i18nKey="sign-up.continue" />
        </button>
      </p>
    </div>
  );
};

export default CoordPart;
